module.exports = __webpack_public_path__ + "img/05.6fe629f5.png";